"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDictionaryColumns = void 0;
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const table_cells_1 = require("../../table/table-cells");
const authored_columns_1 = require("../authored-evidence/authored-columns");
function useDictionaryColumns() {
    const intl = react_intl_1.useIntl();
    const { columnCreated, columnCreatedBy, columnUpdated, columnUpdatedBy, } = authored_columns_1.useAuthoredColumns();
    const columnOrder = react_1.useMemo(() => ({
        datakey: 'order',
        name: intl.formatMessage({
            id: 'EAS_EVIDENCE_COLUMN_ORDER',
            defaultMessage: 'Pořadí',
        }),
        width: 100,
        CellComponent: table_cells_1.TableCells.NumberCell,
        sortable: true,
        filterable: true,
    }), [intl]);
    const columnName = react_1.useMemo(() => ({
        datakey: 'name',
        name: intl.formatMessage({
            id: 'EAS_EVIDENCE_COLUMN_NAME',
            defaultMessage: 'Název',
        }),
        width: 200,
        CellComponent: table_cells_1.TableCells.TextCell,
        sortable: true,
        filterable: true,
    }), [intl]);
    const columnValidFrom = react_1.useMemo(() => ({
        datakey: 'validFrom',
        name: intl.formatMessage({
            id: 'EAS_EVIDENCE_COLUMN_VALID_FROM',
            defaultMessage: 'Platnost od',
        }),
        width: 150,
        CellComponent: table_cells_1.TableCells.DateTimeCell,
        sortable: true,
        filterable: true,
    }), [intl]);
    const columnValidTo = react_1.useMemo(() => ({
        datakey: 'validTo',
        name: intl.formatMessage({
            id: 'EAS_EVIDENCE_COLUMN_VALID_TO',
            defaultMessage: 'Platnost do',
        }),
        width: 150,
        CellComponent: table_cells_1.TableCells.DateTimeCell,
        sortable: true,
        filterable: true,
    }), [intl]);
    const columnActive = react_1.useMemo(() => ({
        datakey: 'active',
        name: intl.formatMessage({
            id: 'EAS_EVIDENCE_COLUMN_ACTIVE',
            defaultMessage: 'Aktivní',
        }),
        width: 100,
        CellComponent: table_cells_1.TableCells.BooleanCell,
        sortable: true,
        filterable: true,
    }), [intl]);
    const columnCode = react_1.useMemo(() => ({
        datakey: 'code',
        name: intl.formatMessage({
            id: 'EAS_EVIDENCE_COLUMN_CODE',
            defaultMessage: 'Kód',
        }),
        width: 100,
        CellComponent: table_cells_1.TableCells.TextCell,
        sortable: true,
        filterable: true,
    }), [intl]);
    const dictionaryColumns = react_1.useMemo(() => [
        columnOrder,
        columnName,
        columnValidFrom,
        columnValidTo,
        columnActive,
        columnCode,
        columnCreated,
        columnCreatedBy,
        columnUpdated,
        columnUpdatedBy,
    ], [
        columnActive,
        columnCode,
        columnName,
        columnOrder,
        columnValidFrom,
        columnValidTo,
        columnCreated,
        columnCreatedBy,
        columnUpdated,
        columnUpdatedBy,
    ]);
    return {
        columnOrder,
        columnName,
        columnValidFrom,
        columnValidTo,
        columnActive,
        columnCode,
        columnCreated,
        columnCreatedBy,
        columnUpdated,
        columnUpdatedBy,
        dictionaryColumns,
    };
}
exports.useDictionaryColumns = useDictionaryColumns;
//# sourceMappingURL=dictionary-columns.js.map